import {Link} from "react-router-dom";
import React from "react";
// Import your images
import EventImage1 from "../assets/photos/community page images/EventImage1.png";
import EventImage2 from "../assets/photos/community page images/EventImage2.png";
import EventImage3 from "../assets/photos/community page images/EventImage3.png";
import EventImage4 from "../assets/photos/community page images/EventImage4.png";
import EventImage5 from "../assets/photos/community page images/EventImage5.png";
import EventImage6 from "../assets/photos/community page images/EventImage6.png";

// Import detailed and additional images for event1
import EventImage1_1 from "../assets/photos/community page images/Event1/Event1.1.jpg";
import EventImage1_2 from "../assets/photos/community page images/Event1/Event1.2.jpg";
import EventImage1_3 from "../assets/photos/community page images/Event1/Event1.3.jpg";
import EventImage1_4 from "../assets/photos/community page images/Event1/Event1.4.jpg";

// Import detailed and additional images for event2
import EventImage2_1 from "../assets/photos/community page images/Event2/Event2.1.jpg";
import EventImage2_2 from "../assets/photos/community page images/Event2/Event2.2.jpg";
import EventImage2_3 from "../assets/photos/community page images/Event2/Event2.3.jpg";
import EventImage2_4 from "../assets/photos/community page images/Event2/Event2.4.jpg";

// Import detailed and additional images for event3
import EventImage3_1 from "../assets/photos/community page images/Event3/Event3.1.png";
import EventImage3_2 from "../assets/photos/community page images/Event3/Event3.2.png";
import EventImage3_3 from "../assets/photos/community page images/Event3/Event3.3.png";
import EventImage3_4 from "../assets/photos/community page images/Event3/Event3.4.png";

// Import detailed and additional images for event4
import EventImage4_1 from "../assets/photos/community page images/Event4/Event4.1.png";
import EventImage4_2 from "../assets/photos/community page images/Event4/Event4.2.png";
import EventImage4_3 from "../assets/photos/community page images/Event4/Event4.3.png";
import EventImage4_4 from "../assets/photos/community page images/Event4/Event4.4.png";

// Import detailed and additional images for event5
import EventImage5_1 from "../assets/photos/community page images/Event5/Event5.1.png";
import EventImage5_2 from "../assets/photos/community page images/Event5/Event5.2.png";
import EventImage5_3 from "../assets/photos/community page images/Event5/Event5.3.png";
import EventImage5_4 from "../assets/photos/community page images/Event5/Event5.4.png";

// Import detailed and additional images for event6
import EventImage6_1 from "../assets/photos/community page images/Event6/Event6.1.png";
import EventImage6_2 from "../assets/photos/community page images/Event6/Event6.2.png";
import EventImage6_3 from "../assets/photos/community page images/Event6/Event6.3.png";
import EventImage6_4 from "../assets/photos/community page images/Event6/Event6.4.png";

const handleScrollToTop = () => {
    window.scrollTo(0, 0);
};

export const communityGroups = [
    {
        slug: "Technovate", // new unique identifier
        title: "Technovate",
        description: "A tech-driven ideation and pitching competition, where students developed innovative healthcare solutions, refining their ideas under expert mentorship.",
        detailedDescription:`
        <div class="space-y-4">
            <p>Technovate was an exciting tech-based competition, where students got the chance to showcase their problem-solving skills and innovative ideas in healthcare technology. Organized by Health-O-Tech during AdVITya'25, featuring six teams of participants.</p>
  
          <div>
            <h3 class="text-xl font-bold mb-2">Event Highlights</h3>
            <div class="ml-4">
                <h4 class="font-semibold">• Inauguration & Introduction:</h4>
                <ul class="list-disc ml-6 mb-2">
                    <li>The event kicked off with a brief introduction, setting the tone for a dynamic session of ideation and technological exploration.</li>
                    <li>The technical team explained the competition structure, ensuring that all participants understood the expectations and judging criteria.</li>
                </ul>
            </div>
        </div>
  
        <div>
            <h4 class="font-semibold">Round 1 – Ideation & Concept Development (9:00 AM - 11:00 AM)</h4>
            <p>In this round, teams had two hours to:</p>
            <ul class="list-disc ml-6 mb-2">
                <li>Brainstorm innovative healthcare solutions.</li>
                <li>Develop a structured PowerPoint presentation to communicate their ideas.</li>
                <li>Receive mentorship from experts, helping them refine their solutions and make them more feasible and impactful.</li>
            </ul>
        </div>

        <div>
            <h4 class="font-semibold">Round 2 – Presentation Round (11:15 AM - 12:40 PM)</h4>
            <p>Teams presented their health-tech innovations to a panel of esteemed judges, including:</p>
            <ul class="list-disc ml-6 mb-2">
                <li>Dr. Swagat Samantaray</li>
                <li>Dr. Xavier Suresh</li>
                <li>Dr. Trapti Sharma</li>
            </ul>
            <p>Each team had four minutes to present, followed by a one-minute Q&A session, where judges assessed their creativity, feasibility, and potential impact.</p>
        </div>

        <div>
            <h4 class="font-semibold">Final Round – The Ultimate Pitch (90 Minutes)</h4>
            <ul class="list-disc ml-6 mb-2">
                <li>Shortlisted teams advanced to the final round, where they had six minutes to present an improved version of their idea.</li>
                <li>Judges then engaged in a two-minute Q&A, challenging participants to defend their ideas, address limitations, and refine their solutions further.</li>
                <li>The event took place at AB (416) from 9 AM to 12 PM, featuring six teams of participants, all from VIT Bhopal.</li>
            </ul>
            <p>The event provided a platform for students to brainstorm, design, and present technological solutions aimed at revolutionizing the healthcare industry.</p>
        </div>

        <div>
            <h3 class="text-xl font-bold mb-2">Awards & Closing Ceremony</h3>
            <p>The event concluded with a grand prize distribution ceremony, recognizing exceptional efforts and groundbreaking ideas. Dr. Ashok Kumar Patel presented a memento to Dr. Trapti Sharma, marking the successful conclusion of the event.</p>
        </div>

        <div>
            <h3 class="text-xl font-bold mb-2">Impact of Technovate</h3>
            <ul class="list-disc ml-6">
                <li>Encouraged students to think like entrepreneurs and innovators, applying technology to solve critical healthcare challenges.</li>
                <li>Provided a hands-on learning experience, bridging the gap between technical skills and real-world problem-solving.</li>
                <li>Inspired participants to pursue careers in health-tech, AI, and data-driven medicine, highlighting the transformative role of technology in healthcare.</li>
            </ul>
        </div>

        <div>
            <h4 class="font-semibold">Evaluation focused on:</h4>
            <ul class="list-disc ml-6">
                <li>Innovation – How unique and disruptive the idea was.</li>
                <li>Feasibility – How practical and implementable the solution would be.</li>
                <li>Impact – The potential effect the idea could have on real-world healthcare challenges.</li>
            </ul>
        </div>
    </div>`,
            
        imageUrl: EventImage1,
        detailedImage: EventImage1_1,
        additionalImages: [
            EventImage1_1,
            EventImage1_2,
            EventImage1_3,
            EventImage1_4
          ],
        additionalDetails: {
            date: "February 21, 2025",
            location: "AB 416 (VIT Bhopal University)",
            time: "09:00 AM"
        },
        link: "/community/Technovate"
    },
    {
        slug: "Fit-A-Minute",
        title: "Fit A Minute",
        description: "A high-energy fitness challenge, featuring team-based endurance and agility tasks, culminating in an intense plank-holding competition to test resilience and teamwork.",
        detailedDescription:`
            <div class="space-y-6">
        <p>The Fit-a-Minute event, organized by Health-O-Tech during AdVITya'25, was an exhilarating blend of fitness, fun, and competitive spirit, aimed at promoting health, endurance, and teamwork among students. Held in Arch (203) from 9 AM to 12 PM, this offline event challenged participants to push their physical and mental limits while fostering sportsmanship and collaboration.</p>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Event Highlights</h3>
            
            <div class="ml-4 space-y-3">
                <div>
                    <h4 class="font-semibold">• Inauguration & Motivational Speeches:</h4>
                    <p class="ml-6">The event was inaugurated with inspiring speeches by Club Coordinator, Dr. Swagat Samantaray, and special guest, Dr. Xavier Suresh, who emphasized the importance of fitness in daily life and encouraged participants to give their best while having fun.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Participation & Format:</h4>
                    <ul class="list-disc ml-10 space-y-1">
                        <li>A total of 39 participants, all from VIT Bhopal, registered for the event.</li>
                        <li>Participants competed in teams (5 teams in total), fostering collaboration and competitive enthusiasm.</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Round 1 – Fitness Challenges (Elimination Round)</h3>
            <p class="mb-2">The first round consisted of five engaging fitness challenges, each designed to test a different aspect of strength, endurance, flexibility, and balance:</p>
            
            <ol class="list-decimal ml-6 space-y-2">
                <li><span class="font-semibold">Pushup Book Balance</span> – A test of upper body strength and stability, requiring participants to perform pushups while balancing a book on their back.</li>
                <li><span class="font-semibold">Bottle Flip Squats</span> – A combination of precision and endurance, where participants had to complete squats while successfully flipping a bottle upright.</li>
                <li><span class="font-semibold">Plank Cup Stack</span> – A core stability and coordination challenge, in which participants had to hold a plank position while stacking cups with one hand.</li>
                <li><span class="font-semibold">One-Leg Balance</span> – A concentration and balance test, where participants were required to maintain a stable stance on one leg for as long as possible.</li>
                <li><span class="font-semibold">Yoga Poses</span> – A flexibility and mindfulness challenge, assessing participants' ability to hold complex yoga poses with proper form.</li>
            </ol>
            
            <p class="mt-2">The top three teams that excelled in these challenges advanced to the final round.</p>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Round 2 – The Ultimate Test (Plank Challenge Finals)</h3>
            <p>The finalists had to hold a plank position for the longest time, testing their core endurance, resilience, and teamwork. This challenge was a true test of mental and physical strength, as participants had to push past their limits while relying on their team's motivation and support.</p>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Awards & Closing Ceremony</h3>
            <p>After an intense showdown, the winners were announced in a celebratory awards ceremony, where Dr. Swagat Samantaray and Dr. Xavier Suresh presented certificates and prizes to the champions. The event concluded with a strong message about the importance of fitness, discipline, and perseverance, leaving participants inspired to incorporate physical activity into their daily routines.</p>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Impact of Fit-a-Minute</h3>
            <ul class="list-disc ml-6 space-y-1">
                <li>Encouraged students to adopt a fitness-oriented lifestyle, proving that exercise can be both fun and rewarding.</li>
                <li>Strengthened teamwork and sportsmanship, as participants learned to support and push each other beyond their limits.</li>
                <li>Reinforced the idea that small daily efforts toward fitness can lead to long-term health benefits, making a positive impact on participants' physical and mental well-being.</li>
            </ul>
        </div>
    </div>        
        `,
        imageUrl: EventImage2,
        detailedImage: EventImage2_1,
        additionalImages: [
            EventImage2_1,
            EventImage2_2,
            EventImage2_3,
            EventImage2_4
          ],
        additionalDetails: {
            date: "February 22, 2025",
            location: "Arch 103 (VIT Bhopal University)",
            time: "09:00 AM"
        },
        link: "/community/Fit-A-Minute"
    },
    {
        slug: "Pulse-2.0",
        title: "Pulse 2.0",
        description: "A grand tech and career festival featuring IBM’s Yash Awidra, blending industry insights, live Q&A, leadership felicitation, and a cultural music performance",
        detailedDescription:`
            <div class="space-y-6">
        <p>After the massive success of PULSE 1.0, the Health-O-Tech team set out to create an even bigger, more impactful experience, leading to the launch of PULSE 2.0. This event wasn't just about career guidance—it was a fusion of technology, professional development, and cultural engagement, ensuring students left inspired, skilled, and ready to take on the future.</p>
        
        <p>Held in a grand offline setting, PULSE 2.0 brought together top industry leaders, passionate students, and high-energy cultural performances.</p>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Key Moments of PULSE 2.0</h3>
            
            <div class="ml-4 space-y-3">
                <div>
                    <h4 class="font-semibold">• Chief Guests:</h4>
                    <ul class="list-disc ml-10 space-y-1">
                        <li>Dr. Chandan Kumar Behera (Assistant Dean, Student Welfare)</li>
                        <li>Dr. Pon Harshwardhan (Dean, School of Computing & Information Technology)</li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Keynote Speaker:</h4>
                    <p class="ml-6">Mr. Yash Awidra, a leading Application Developer at IBM and former Software Developer at Mercedes-Benz, delivered an in-depth session on mobile development, UI/UX, and industry trends.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Live Q&A with Mr. Awidra:</h4>
                    <p class="ml-6">Students engaged in direct discussions on how to break into the tech industry, the importance of UI/UX in product development, and strategies to future-proof their careers.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Live Band Performance:</h4>
                    <p class="ml-6">Unlike traditional career events, PULSE 2.0 introduced an energetic cultural aspect, featuring a 20-minute live band performance that added enthusiasm and vibrancy to the event.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Felicitation Ceremony:</h4>
                    <p class="ml-6">A grand introduction of the new club leadership team, ensuring a seamless transition and continuity of impactful events.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Networking & Closing Remarks:</h4>
                    <p class="ml-6">The event ended with an interactive networking session, allowing students to build professional connections, seek mentorship, and interact with the guest speakers.</p>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">The Impact of PULSE 2.0</h3>
            
            <ul class="list-disc ml-6 space-y-2">
                <li>Bridged the gap between students and industry leaders, ensuring real-world exposure to corporate expectations.</li>
                <li>Integrated learning with entertainment, proving that professional growth doesn't have to be dull—it can be exciting, engaging, and fun.</li>
                <li>Encouraged students to be proactive about their careers, helping them gain insights into upcoming trends in the tech industry.</li>
            </ul>
        </div>
        
        <p class="font-medium mt-4">PULSE 2.0 was more than just an event—it was an unforgettable experience, setting the stage for future career-focused, high-impact gatherings at VIT Bhopal.</p>
    </div>
        `,
        imageUrl: EventImage3,
        detailedImage: EventImage3_1,
        additionalImages: [
            EventImage3_1,
            EventImage3_2,
            EventImage3_3,
            EventImage3_4
          ],
        additionalDetails: {
            date: "August 09, 2024",
            location: "Auditorium 2 (VIT Bhopal University)",
            time: "10:00 AM"
        },
        link: "/community/Pulse-2.0"
    },
    {
        slug: "Hack4Health",
        title: "Hack4Health",
        description: "A two-day health-tech hackathon where teams developed innovative solutions for real-world medical challenges, judged by Dr. D. Lakshmi and Dr. Rudra Kalyan.",
        detailedDescription:`
            <div class="space-y-6">
        <p>Hackathons are intense by nature, but Hack4Health brought a unique twist by focusing on technology-driven solutions for healthcare challenges. This two-day event wasn't just about building an app or writing code—it was about creating something that could genuinely improve healthcare outcomes.</p>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Event Structure</h3>
            
            <div class="ml-4 space-y-4">
                <div>
                    <h4 class="font-semibold">• Day 1: Exploring AI in Healthcare</h4>
                    <p class="ml-6">The event started with a thought-provoking Q&A session on Generative AI in Healthcare, where participants explored how artificial intelligence is revolutionizing medicine. The session, led by faculty experts, provided the foundation for what the participants would be tackling next.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Day 2: Solution Development</h4>
                    <p class="ml-6">Teams were given real-world healthcare problems to solve using innovative tech solutions. Judges Dr. D. Lakshmi and Dr. Rudra Kalyan evaluated the projects based on feasibility, impact, and technical execution.</p>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Winning Solutions</h3>
            <p>The competition was fierce, but the top teams presented remarkable innovations, from AI-based early disease detection systems to real-time patient monitoring dashboards. The winning teams were awarded medals and certificates, but more importantly, they gained invaluable hands-on experience in building solutions that could one day change lives.</p>
            
            <div class="ml-4 mt-3">
                <ul class="list-disc ml-6 space-y-2">
                    <li><span class="font-semibold">First Place:</span> An AI-powered symptom analysis tool that helps rural healthcare providers make more accurate diagnoses with limited resources.</li>
                    <li><span class="font-semibold">Second Place:</span> A wearable device interface that monitors vital signs and alerts caregivers of potential emergencies for elderly patients.</li>
                    <li><span class="font-semibold">Third Place:</span> A blockchain-based medical record system that securely maintains patient history across different healthcare providers.</li>
                </ul>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Long-Term Impact</h3>
            <p>This event bridged the gap between healthcare and technology, demonstrating that students, with the right guidance, can create solutions to real-world medical problems. It inspired participants to explore health-tech careers and further research in medical AI, bioinformatics, and wearable health monitoring systems.</p>
            
            <div class="ml-4 mt-3">
                <h4 class="font-semibold">• Key Outcomes:</h4>
                <ul class="list-disc ml-6 space-y-2">
                    <li>Fostered interdisciplinary collaboration between technology and healthcare students</li>
                    <li>Created a platform for students to showcase their problem-solving abilities to industry professionals</li>
                    <li>Introduced participants to the growing field of health technology innovation</li>
                    <li>Developed practical solutions with potential for real-world implementation</li>
                </ul>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Judging Criteria</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 ml-4">
                <div class="bg-white/10 p-4 rounded-lg">
                    <h4 class="font-semibold text-center mb-2">Technical Innovation</h4>
                    <p class="text-center">Creativity and novelty of the technological approach</p>
                </div>
                <div class="bg-white/10 p-4 rounded-lg">
                    <h4 class="font-semibold text-center mb-2">Medical Impact</h4>
                    <p class="text-center">Potential to improve patient outcomes or healthcare efficiency</p>
                </div>
                <div class="bg-white/10 p-4 rounded-lg">
                    <h4 class="font-semibold text-center mb-2">Feasibility</h4>
                    <p class="text-center">Practicality of implementation in real-world healthcare settings</p>
                </div>
            </div>
        </div>
    </div>
        `,
        imageUrl: EventImage4,
        detailedImage: EventImage4_1,
        additionalImages: [
            EventImage4_1,
            EventImage4_2,
            EventImage4_3,
            EventImage4_4
          ],
        additionalDetails: {
            date: "December 9-10, 2024",
            location: "VIT Bhopal University",
            time: "2:00 PM"
        },
        link: "/community/Hack4Health"
    },
    {
        slug: "Revive",
        title: "Revive",
        description: "A World Mental Health Day initiative with psychologist Ms. Shikha Jha, combining a nukkad natak, interactive activities, and open discussions to break mental health stigma.",
        detailedDescription:`
             <div class="space-y-6">
        <p>Mental health remains one of the most misunderstood and overlooked aspects of student life, despite the tremendous pressures students face in academics, career decisions, and personal struggles. Recognizing this, Health-O-Tech organized REVIVE on World Mental Health Day, creating a safe space for open discussions, self-expression, and awareness.</p>
        
        <p>Held in the VIT Bhopal Auditorium, the event saw 130 students participating in highly interactive sessions aimed at breaking stigmas, debunking myths, and promoting mental well-being.</p>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Key Highlights of REVIVE</h3>
            
            <div class="ml-4 space-y-4">
                <div>
                    <h4 class="font-semibold">• Guest Speaker:</h4>
                    <p class="ml-6">Ms. Shikha Jha, a renowned counseling psychologist and researcher, led the seminar, addressing common mental health issues, stress management techniques, and the importance of emotional resilience.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Icebreaker Activity – "Vent It All Out" Board:</h4>
                    <p class="ml-6">As students entered the venue, they were encouraged to write down their emotions on sticky notes.</p>
                    <ul class="list-disc ml-10 space-y-1">
                        <li>Positive thoughts were placed in a box, signifying hope and gratitude.</li>
                        <li>Negative thoughts were posted on the "Vent It All Out" board, symbolizing a release of stress and bottled-up emotions.</li>
                        <li>This simple but powerful exercise helped students acknowledge their emotions while encouraging self-expression without judgment.</li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Cultural Performance – Nukkad Natak "Pinjara":</h4>
                    <ul class="list-disc ml-10 space-y-1">
                        <li>A raw, gripping street play performed by talented students, portraying the struggles of mental health, societal pressure, and the impact of stigma.</li>
                        <li>The performance was deeply moving, leaving many in the audience emotional and sparking meaningful conversations about mental health.</li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Bollywood Mental Health Game:</h4>
                    <ul class="list-disc ml-10 space-y-1">
                        <li>A fun yet insightful game where students had to guess Bollywood movies that addressed mental health themes.</li>
                        <li>Movies like Dear Zindagi, Taare Zameen Par, and Chhichhore were highlighted, opening discussions on how mental health is portrayed in popular culture.</li>
                    </ul>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Open Mic Session:</h4>
                    <p class="ml-6">A space for students to express themselves through poetry, storytelling, and music, allowing them to channel their emotions into art.</p>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">The Lasting Impact of REVIVE</h3>
            <ul class="list-disc ml-6 space-y-2">
                <li>Encouraged students to seek help and talk about their mental health openly.</li>
                <li>Provided real-world coping strategies, such as mindfulness techniques, stress reduction exercises, and the importance of seeking professional help when needed.</li>
                <li>Created a community-driven approach to mental health, where students felt heard, supported, and empowered to help others.</li>
            </ul>
        </div>
        
        <p class="font-medium italic mt-4">REVIVE wasn't just an event—it was a movement towards a healthier, more empathetic campus culture, ensuring that mental well-being is prioritized as much as academic success.</p>
    </div>
        `,
        imageUrl: EventImage5,
        detailedImage: EventImage5_1,
        additionalImages: [
            EventImage5_1,
            EventImage5_2,
            EventImage5_3,
            EventImage5_4
          ],
        additionalDetails: {
            date: "October 12, 2023",
            location: "Auditorium 1 (VIT Bhopal University)",
            time: "10:00 AM"
        },
        link: "/community/Revive"
    },
    {
        slug: "Tech-Siege",
        title: "Tech Siege",
        description: "A thrilling team-based competition featuring rounds like VIT Feud, Jenga Jam, and Medical Mystery, designed to test strategy, problem-solving, and collaboration.",
        detailedDescription:`
            <div class="space-y-6">
        <p>Technology and critical thinking took center stage in Tech Siege – AdVITya 2024, a highly competitive team-based challenge that pushed participants to think on their feet while navigating three strategically designed rounds. The event wasn't just about winning—it was about adapting to challenges, working as a team, and making quick decisions under pressure.</p>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Competition Rounds</h3>
            
            <div class="ml-4 space-y-4">
                <div>
                    <h4 class="font-semibold">• Round 1 – VIT Feud</h4>
                    <p class="ml-6">Teams competed in a survey-based quiz, testing their logical reasoning and knowledge across various domains. The challenge wasn't just about knowing the right answer—it was about understanding how people think, making it a game of strategy as much as intellect.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Round 2 – Jenga Jam</h4>
                    <p class="ml-6">A creative spin on the classic game Jenga, where teams had to remove blocks carefully while facing knowledge-based challenges. The twist? Losing teams faced additional penalties, making the competition even more intense.</p>
                </div>
                
                <div>
                    <h4 class="font-semibold">• Round 3 – Medical Mystery</h4>
                    <p class="ml-6">The final and most exciting round required teams to solve a healthcare-related mystery using clues hidden across the campus. This wasn't just a test of intellect but also of collaboration and critical problem-solving under time constraints.</p>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Skills Developed</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 ml-4">
                <div class="bg-white/10 p-4 rounded-lg flex flex-col items-center">
                    <h4 class="font-semibold text-center mb-2">Strategic Thinking</h4>
                    <p class="text-center">Planning approaches to complex problems with limited information</p>
                </div>
                <div class="bg-white/10 p-4 rounded-lg flex flex-col items-center">
                    <h4 class="font-semibold text-center mb-2">Team Collaboration</h4>
                    <p class="text-center">Leveraging diverse skills and perspectives to achieve common goals</p>
                </div>
                <div class="bg-white/10 p-4 rounded-lg flex flex-col items-center">
                    <h4 class="font-semibold text-center mb-2">Decision-Making</h4>
                    <p class="text-center">Making effective choices under pressure and time constraints</p>
                </div>
                <div class="bg-white/10 p-4 rounded-lg flex flex-col items-center">
                    <h4 class="font-semibold text-center mb-2">Adaptability</h4>
                    <p class="text-center">Quickly adjusting strategies when faced with unexpected challenges</p>
                </div>
            </div>
        </div>
        
        <div>
            <h3 class="text-xl font-bold mb-3">Why This Event Mattered</h3>
            <p>Tech Siege wasn't just a competition—it was a learning experience that enhanced strategic thinking, teamwork, and real-time decision-making. The integration of technology and logic-based challenges made it a unique and highly engaging event. Participants left with a heightened ability to think on their feet and work under pressure, key skills that will serve them in both their academic and professional journeys.</p>
            
            <div class="ml-4 mt-4">
                <ul class="list-disc ml-6 space-y-2">
                    <li>Created a platform for students to apply theoretical knowledge to practical, time-bound challenges</li>
                    <li>Fostered healthy competition while emphasizing the importance of collaboration</li>
                    <li>Introduced healthcare-related problem-solving in an engaging, gamified format</li>
                    <li>Simulated real-world scenarios where decisions must be made quickly with limited information</li>
                </ul>
            </div>
        </div>
        
        <div class="bg-white/10 p-6 rounded-lg mt-6">
            <h3 class="text-xl font-bold mb-3 text-center">Participant Feedback</h3>
            <p class="italic text-center">"Tech Siege challenged us in ways we didn't expect. It wasn't just about what we knew, but how quickly we could apply that knowledge under pressure. The most valuable lesson was learning to trust our teammates' strengths while navigating complex challenges."</p>
            <p class="text-right mt-2">— Winning Team Captain</p>
        </div>
    </div>
        `,
        imageUrl: EventImage6,
        detailedImage: EventImage6_1,
        additionalImages: [
            EventImage6_1,
            EventImage6_2,
            EventImage6_3,
            EventImage6_4
          ],
        additionalDetails: {
            date: "February 23, 2024",
            location: "VIT Bhopal University",
            time: "2:00 PM"
        },
        link: "/community/Tech-Siege"
    },
];

const CommunityPage = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 pt-24 px-4 md:px-20 ">
            <h1 className="text-3xl md:text-5xl font-bold text-white text-center mb-10 mt-8">
                Our Community Events
            </h1>

            <div className="flex flex-col items-center space-y-8 pb-10">
                {communityGroups.map((group, index) => (
                    <Link
                        to={group.link}
                        onClick={handleScrollToTop}
                        key={index}
                        className="w-full max-w-7xl max-h-36 bg-white/20 backdrop-blur-lg border border-white/30 rounded-xl overflow-hidden shadow-xl transform transition-all duration-300 hover:scale-[1.02] flex"
                    >
                        <div className="w-[30%] md:w-[20%] flex-shrink-0">
                <img
                    src={group.imageUrl}
                    alt={group.title}
                    className="w-full h-full object-cover"
                />
            </div>
            
            {/* Text container with remaining space */}
            <div className="w-[70%] md:w-[80%] p-4 md:p-6 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-semibold text-white mb-2 md:mb-4">
                    {group.title}
                </h3>
                <p className="text-sm md:text-base text-white/80 line-clamp-2 md:line-clamp-none">
                    {group.description}
                </p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default CommunityPage;